import { useLocation } from 'react-router-dom';
import I18n from 'I18n';
import { getFullDeepLinkUrlFromPathName } from '../../url/getDeepLinkUrl';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { copyWithFloatingMessage } from '../../util/copyToClipboard';
import ActionButtonComponent from '../ActionButtonComponent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DuplicateIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const DeepLinkButton = ({
  collapsed,
  genericChannelId,
  messageId
}) => {
  const location = useLocation();
  const onClick = () => {
    copyWithFloatingMessage(getFullDeepLinkUrlFromPathName(location, messageId), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.deepLinkCopied"
    }));
    usageTracker.track('copy-message', {
      action: 'copy message',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    onClick: onClick,
    collapsed: collapsed,
    buttonIcon: DuplicateIcon,
    "data-test-id": 'deep-link-button',
    i18nButtonText: I18n.text('conversations-inbox-message-history.common-message.deepLink')
  });
};
DeepLinkButton.displayName = 'DeepLinkButton';
export default DeepLinkButton;